import axios from 'axios'
import FormData from 'form-data'

const host = 'https://oriensstaging.oriens.my.id'

export const uploadMedia = (file, documentId, progressEvent) => {
  const data = new FormData()
  data.append('document_uuid', documentId)
  data.append('file', file)
  const uri = `${host}/imageEditor`

  return axios.post(uri, data, {
    mode: 'no-cors',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: progressEvent,
  })
}
